import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "35",
  height: "35",
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M22.9062 5.5326C23.4757 6.10212 23.4757 7.02549 22.9062 7.595L12.9999 17.5013L22.9062 27.4076C23.4757 27.9771 23.4757 28.9005 22.9062 29.47C22.3366 30.0395 21.4133 30.0395 20.8438 29.47L9.90626 18.5325C9.33675 17.963 9.33675 17.0396 9.90626 16.4701L20.8438 5.5326C21.4133 4.96309 22.3366 4.96309 22.9062 5.5326Z",
      fill: "#0A072D"
    }, null, -1)
  ])))
}
export default { render: render }